import { render, staticRenderFns } from "./tab-baseinfo.vue?vue&type=template&id=69fed72e&scoped=true"
import script from "./tab-baseinfo.vue?vue&type=script&lang=js"
export * from "./tab-baseinfo.vue?vue&type=script&lang=js"
import style0 from "./tab-baseinfo.vue?vue&type=style&index=0&id=69fed72e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69fed72e",
  null
  
)

export default component.exports